<!--@if (!isLoading()) {
  <app-scheme-card [scheme]="scheme()!"></app-scheme-card>
}-->
<mat-grid-list cols="4" gutterSize="16px">
  @for (scheme of schemes(); track scheme.schematicId) {
    <mat-grid-tile>
      <app-scheme-card [scheme]="scheme"></app-scheme-card>
    </mat-grid-tile>
  }
</mat-grid-list>
<div #sentinel class="scroll-sentinel"></div>
